import cn from 'classnames'
import * as React from 'react'

import useComponentVisible from 'hooks/useComponentVisible'

import { FieldWrapper } from 'components/FieldWrapper'
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper'

import { ReactComponent as ArrowDown } from 'assets/images/svg/arrow_down.svg'
import { ReactComponent as CheckIcon } from 'assets/images/svg/check.svg'

import styles from './AppSelect.module.scss'

interface Props {
  text?: string
  placeholder?: string
  multiple?: boolean
  defaultValues?: any[]
  containerClassName?: string
  size?: 'small' | 'medium' | 'extra_small'
  onChangeValues?(values: any[]): void
  list: {
    title: string
    value: any
  }[]
}

export const AppSelect: React.FC<Props & FieldWrapperProps> = ({
  multiple = false,
  defaultValues = [],
  list,
  onChangeValues,
  text,
  size = 'medium',
  placeholder = 'Выбрать',
  containerClassName,
  ...props
}) => {
  const [values, setValues] = React.useState<any[]>(defaultValues)
  const { ref, setIsComponentVisible, isComponentVisible } =
    useComponentVisible<HTMLDivElement>(false)

  const onSelectValue = (value: any) => {
    const has = values.includes(value)
    if (has) {
      setValues(prev => prev.filter(item => item !== value))
      return
    }
    if (multiple) {
      setValues(prev => [...prev, value])
      return
    }
    setIsComponentVisible(false)
    setValues([value])
  }
  const toggleDropdown = React.useCallback(() => {
    setIsComponentVisible(prev => !prev)
  }, [setIsComponentVisible])

  const selectContainerClass = {
    small: styles.selectSmall,
    medium: styles.selectMedium,
    extra_small: styles.selectExtraSmall,
  }

  React.useEffect(() => {
    onChangeValues?.(values)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  return (
    <FieldWrapper containerClassName={containerClassName} {...props}>
      <div
        ref={ref}
        className={cn(styles.container)}
        title={text || placeholder}
      >
        <div
          onClick={toggleDropdown}
          className={cn(
            styles.select,
            isComponentVisible ? styles.select__active : null,
            selectContainerClass[size],
          )}
        >
          <div className={cn(styles.text, text ? styles.text__active : null)}>
            {text || placeholder}
          </div>
          <div className={styles.icon}>
            <ArrowDown width={12} height={12} />
          </div>
        </div>
        {isComponentVisible ? (
          <div className={styles.dropdown}>
            {list.map(item => {
              const isActive = values.includes(item.value)
              return (
                <div
                  key={item.value}
                  onClick={() => onSelectValue(item.value)}
                  className={styles.dropdown__item}
                >
                  <div className={styles['dropdown__item--text']}>
                    {item.title}
                  </div>
                  {multiple ? (
                    <div
                      className={cn(
                        styles['dropdown__item--checkbox'],
                        isActive
                          ? styles['dropdown__item--checkbox__active']
                          : null,
                      )}
                    >
                      <CheckIcon />
                    </div>
                  ) : null}
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    </FieldWrapper>
  )
}
